import { render, staticRenderFns } from "./CustomerCustomerMessageActive.vue?vue&type=template&id=7aa5744f"
import script from "./CustomerCustomerMessageActive.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerMessageActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports